var map = {
	"./background.jpeg": 477,
	"./c.png": 97,
	"./cr.webp": 407,
	"./i.jpg": 107,
	"./l.webp": 162,
	"./logo.jpg": 769,
	"./m.webp": 189,
	"./r.png": 560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;